import script from "./btnAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./btnAnimation.vue?vue&type=script&setup=true&lang=js"

import "./btnAnimation.vue?vue&type=style&index=0&id=477c906c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477c906c"]])

export default __exports__